import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  PRODUCT_SURVEILLANCE,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_BAXTER_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_BAXTER,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_BAXTER_EMPLOYEE,
  DATE_MESSAGE_BAXTER_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_BAXTER_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_BAXTER_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  BAXTER_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  BAXTER_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_BAXTER,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  BAXTER_EMAIL_ADDRESS,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  BAXTER_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_BAXTER,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "Portale per il Riscontro sull'Esperienza Prodotto";
translations[LANDING_BRIEF] = "Il Portale online per il Riscontro sull'Esperienza Prodotto è destinato alla raccolta confidenziale di informazioni e riscontri riguardo a tutti i prodotti Baxter.";
translations[LANDING_LANGUAGE_SELECTOR] = "Seleziona la lingua di preferenza";
translations[LANDING_COUNTRY_SELECTOR] = "Seleziona il paese in cui è avvenuto l'evento";
translations[LANDING_TERMS] = "Ho letto e accetto le Condizioni d'uso e l'Informativa sulla Privacy del Portale Riscontro sull'Esperienza Prodotto.";
translations[LANDING_TERMS_ERROR] = "E' obbligatorio leggere ed accettare i contenuti delle Condizioni d'Utilizzo, dell'Informativa sulla Privacy e i Termini d'Utilizzo supplementari riguardanti il Portale online per il Riscontro sull'Esperienza Prodotto.";
translations[LANDING_CAPTCHA_ERROR] = "Verifica che non sei un robot.";
translations[APP_DESCRIPTION] = "Il Portale online per Riscontro sull'Esperienza dei Prodotti Baxter è destinato alla raccolta di tutte le informazioni necessarie riguardanti i prodotti. Se ha riscontrato qualsiasi problema con un prodotto Baxter, la invitiamo a segnalarlo e a condividere qui tutti i dettagli dell'evento. Tutte le segnalazioni sono essenziali per raggiungere i nostri obiettivi, per migliorare continuamente i prodotti e la vostra soddisfazione.";
translations[LANDING_TERMS_I_HAVE_READ] = "Ho letto l'Informativa sulla privacy collegata per il portale di feedback sui prodotti Baxter e comprendo che Baxter Healthcare Corporation («Baxter») sta chiedendo il mio consenso all'utilizzo, alla divulgazione e al trattamento dei miei dati personali per gli scopi e come descritti nell'Informativa sulla privacy. Con la presente acconsento a:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "L'uso, la divulgazione, l'archiviazione e il trattamento dei miei dati personali (inclusi eventuali dati sensibili, come i dati relativi alla salute, che scelgo di fornire) per le finalità descritte nell'Informativa sulla privacy.";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "Il trasferimento dei miei dati personali (compresi i dati sensibili, come i dati relativi alla salute, che scelgo di fornire) fuori dal mio paese e verso un altro paese che potrebbe avere leggi meno rigide o assenti sulla protezione dei dati.";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "Comprendo che questo consenso è volontario e che posso cambiare idea in qualsiasi momento e revocare il mio consenso contattando Baxter utilizzando i dettagli di contatto forniti nell'Informativa sulla privacy. Comprendo che la revoca del mio consenso non influirà sulla liceità del trattamento prima della revoca.";
translations[MENU_FEEDBACK_FORM] = "Iniziare una segnalazione su un prodotto ";
translations[MENU_FEEDBACK_STATUS] = "Verificare lo stato della segnalazione su un prodotto";
translations[MENU_FORM_INTAKE] = "Reporter/Informazioni del contatto";
translations[MENU_FORM_EVENT_DETAILS] = "Dettagli dell'evento";
translations[MENU_FORM_PRODUCT_INFO] = "Informazioni sul prodotto";
translations[SYSTEM_FEEDBACK_FORM] = "Iniziare il modulo di segnalazione su un prodotto";
translations[SYSTEM_FEEDBACK_STATUS] = "Verificare lo stato della segnalazione sul prodotto";
translations[SUBMIT_FEEDBACK] = "Cliccare qui per inviare una segnalazione.";
translations[CHECK_SUBMITTED_FEEDBACK] = "Cliccare qui per verificare lo stato di una segnalazione inviata in precedenza.";
translations[BTN_LAUNCH_FORM] = "Mandare il modulo ";
translations[BTN_CHECK_STATUS] = "Verificare stato";
translations[FORM_TITLE] = "Modulo per la segnalazione su un prodotto";
translations[FORM_SUB_TITLE] = "Se ci sono più pazienti coinvolti, per favore compilare il modulo per ogniuno di loro ";
translations[FORM_MANDATORY_FIELDS] = "Tutti i campi con * sono obbligatori";
translations[BUTTON_PREV] = "Precedente ";
translations[BUTTON_NEXT] = "Avanti ";
translations[BUTTON_SUBMIT] = "Invia";
translations[SELECT_RESPONSE] = "Selezionare una risposta";
translations[FUNCTION_ROLE] = "Funzione/Ruolo";
translations[CUSTOMER_ACCOUNT_NUMBER] = "Codice cliente";
translations[ENTER_CUSTOMER_ACCOUNT] = "Inserire il codice cliente";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "Qual è il codice del cliente coinvolto nell'evento segnalato?";
translations[EVENT_REPORTED] = "Questo evento è stato precedentemente segnalato (a Baxter o a qualsiasi altra entità)?";
translations[REFERENCE_NUMBER] = "Numero di riferimento associato a questo evento";
translations[ENTER_REFERENCE] = "Inserire un riferimento";
translations[WHO_REPORTED_TO] = "A chi è stato segnalato?";
translations[WHO_WAS_NOTIFIED] = "Fornire il nome dell'ente che è stato notificato";
translations[ENTER_NAME] = "Inserire il nome";
translations[PRODUCT_SURVEILLANCE] = "La Sorveglianza sui Prodotti Baxter può contattare te o qualcun altro per sottoporre ulteriori domande?";
translations[YOUR_NAME] = "Il tuo nome";
translations[OCCUPATION] = "Occupazione";
translations[PHONE_NUMBER] = "Numero di telefono";
translations[ENTER_PHONE_NUMBER] = "Inserire il numero di telefono";
translations[ENTER_EMAIL] = "Inserire l'e-mail";
translations[EMAIL_ADDRESS] = "Indirizzo e-mail";
translations[ENTER_ADDRESS] = "Inserire l'indirizzo e-mail";
translations[ENTER_NA_IF_UNKNOWN] = "Inserire NA se sconosciuto";
translations[FACILITY_HOSPITAL] = "Nome della struttura/azienda ospedaliera o del distributore (se applicabile)";
translations[ENTER_FACILITY] = "Inserire la struttura opedaliera";
translations[ADDRESS_1] = "Indirizzo 1";
translations[ADDRESS_2] = "Indirizzo 2";
translations[CITY] = "Città ";
translations[STATE] = "Stato ";
translations[POSTAL_CODE] = "Codice postale";
translations[COUNTRY] = "Paese";
translations[END_USER_CUSTOMER] = "Questo problema è stato scoperto dall'utilizzatore finale/cliente?";
translations[ADDITIONAL_CONTACT_PERSON] = "Persona indicata come contatto aggiuntivo";
translations[ADDITIONAL_PHONE] = "Numero di telefono del contatto aggiuntivo";
translations[ADDITIONAL_EMAIL] = "Email del contatto aggiuntivo";
translations[ANOTHER_FACILITY_ADDRESS] = "Aggiungere un'altra struttura e il suo indirizzo";
translations[ANOTHER_FACILITY_HOSPITAL] = "Nome di un'altra struttura/azienda ospedaliera o distributore (se applicabile)";
translations[ANOTHER_ENTER_FACILITY] = "Inserire la struttura opedaliera";
translations[ANOTHER_ADDRESS_1] = "Indirizzo 1";
translations[ANOTHER_ADDRESS_2] = "Indirizzo 2";
translations[ANOTHER_CITY] = "Città ";
translations[ANOTHER_STATE] = "Stato ";
translations[ANOTHER_POSTAL_CODE] = "Codice postale";
translations[ANOTHER_COUNTRY] = "Paese";
translations[LOT_SERIAL_NUMBER] = "Numero lotto/numero di serie";
translations[ENTER_LOT_SERIAL_NUMBER] = "Inserire il numero di lotto/numero di serie";
translations[HELP_LOT_SERIAL_NUMBER] = "Inserire 'Sconosciuto' se non si conosce il lotto o il numero di serie del prodotto. Oppure inserire 'Chiesto ma Sconosciuto' se è stato chiesto a chi riporta l'evento il lotto o il numero di serie del prodotto ma questo non ne è a conoscenza.";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "Codice del prodotto";
translations[PRODUCT_CODE] = "Codice del prodotto";
translations[ENTER_PRODUCT_CODE] = "Inserire il codice prodotto";
translations[HELP_PRODUCT_CODE] = "Inserire 'Sconosciuto' se non si conosce il codice del prodotto. Oppure  inserire 'Chiesto ma Sconosciuto' se se è stato chiesto a chi riporta l'evento il codice del prodotto ma questo non ne è a conoscenza.";
translations[NDC] = "Codice Classificazione Nazionale Farmaci (NDC)";
translations[ENTER_NDC] = "Immettere codice NDC di identificazione del farmaco";
translations[UDI] = "Codice  di Identificazione unica del dispositivo medico (UDI)";
translations[ENTER_UDI] = "Inserire codice UDI di identificazione unica del dispositivo medico ";
translations[PRODUCT_NAME] = "Nome del prodotto";
translations[ENTER_PRODUCT_NAME] = "Inserire il nome del prodotto";
translations[HELP_PRODUCT_NAME] = "Fornire il nome o la descrizione del prodotto";
translations[BEST_DESCRIBES] = "Effettuare la selezione che descriva meglio il problema segnalato";
translations[QUANTITY_TO_SELECT] = "Quantità da selezionare";
translations[ENTER_QUANTITY] = "Inserire la quantità";
translations[HELP_QUANTITY] = "Numero di prodotti che presentano il problema segnalato";
translations[UNIT] = "Unità ";
translations[AVAILABLE_TO_RETURNED] = "Il prodotto oggetto della segnalazione è disponibile per essere restituito a Baxter per la valutazione?";
translations[PHOTOGRAPH_AVAILABLE] = "È disponibile una fotografia o un video del prodotto oggetto della segnalazione?";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "Assicurati che il problema segnalato sia visibile nella foto o nel video.";
translations[UPLOAD_IMAGES] = "Carica immagini";
translations[REPORTER_NAME] = "Nome della persona che ha effettuato la segnalazione";
translations[REPORTER_FACILITY] = "Struttura in cui si trova della persona che ha effettuato la segnalazione";
translations[REPORTER_OCCUPATION] = "Occupazione della persona che ha effettuato la segnalazione";
translations[ENTER_NUMBER] = "Inserire il numero";
translations[REPORTER_PHONE_NUMBER] = "Numero di telefono della persona che ha effettuato la segnalazione";
translations[REPORTER_EMAIL_ADDRESS] = "Indirizzo e-mail della persona che ha effettuato la segnalazione";
translations[EMPLOYEE_NAME] = "Nome del dipendente";
translations[EMPLOYEE_PHONE_NUMBER] = "Numero di telefono del dipendente";
translations[EMPLOYEE_EMAIL_ADDRESS] = "Indirizzo e-mail del dipendente";
translations[RETURNING_FOR_INVESTIGATION] = "Quanti campioni (in unità) con il problema segnalato vengono restituiti per l'indagine?";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "Questi campioni devono avere il problema segnalato.";
translations[UNUSED_BAXTER_PRODUCT] = "E' disponibile un (1) prodotto non utilizzato dello stesso lotto del prodotto Baxter oggetto della segnalazione per essere restituito a Baxter per la sua valutazione?";
translations[YOU_INDICATED_SAMPLES] = "Se i campioni sono stati indicati come disponibili per la valutazione, si è in grado di consegnarli al relativo distributore di prodotti sanitari?";
translations[SAMPLE_RETURN_KIT] = "Se i campioni sono stati indicati come disponibili per la valutazione, si prega di confermare l'indirizzo fornito affinchè possa essere inviato il kit per la restituzione del campione:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "Una scatola con un'etichetta prepagata verrà inviata a questo indirizzo per restituire il campione in oggetto ";
translations[SAME_AS_MY_ADDRESS] = "Stesso indirizzo";
translations[OTHER_CONTACT_NAME] = "Nome dell'altro contatto";
translations[OTHER_CONTACT_OCCUPATION] = "Occupazione dell'altro contatto";
translations[OTHER_CONTACT_PHONE_NUMBER] = "Numero di telefono dell'altro contatto";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "Indirizzo e-mail dell'altro contatto";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "Se il prodotto da Lei selezionato è fabbricato da un'altra azienda, possiamo fornire le informazioni riguardanti il Suo contatto nel caso in cui avessero ulteriori domande sulla segnalazione?";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "Il cliente ha chiesto esplicitamente che gli vengano forniti i risultati delle indagini?";
translations[EXPLICITLY_REQUEST_CREDIT] = "Il cliente ha richiesto esplicitamente credito per il dispositivo?";
translations[PRODUCT_FROM_BAXTER] = "Il cliente ordina il prodotto direttamente da Baxter?";
translations[QUANTITY_REQUESTED_CREDIT] = "Fornire il numero del lotto del prodotto e la quantità richiesta per il credito:";
translations[ENTER_OCCUPATION] = "Inserire l'occupazione";
translations[LOT_QUANTITY_NUMBER] = "Inserire il numero del lotto e la quantità";
translations[WHOLESALERS_NAME] = "Qual è il nome e l'indirizzo del grossista (città, stato)";
translations[PLACE_WHOLESALERS_NAME] = "Qual è il nome e l'indirizzo del grossista (città, stato)";
translations[ADD_PRODUCT_TO_THE_GRID] = "Aggiungi il prodotto alla lista";
translations[SAVE] = "Salva";
translations[CANCEL] = "Cancella";
translations[ADD_MORE_PRODUCTS] = "AGGIUNGI altri prodotti";
translations[REPORTER_ADDRESS] = "Indirizzo della persona che ha effettuato la segnalazione";
translations[ATTACHMENTS] = "Allegati";
translations[DATE_OF_EVENT] = "Data dell'evento";
translations[DATE_OF_EVENT_MSG] = "La data dell'evento non può essere precedente alla data della prima notifica effettuata ad un dipendente Baxter. Inserire una data valida.";
translations[HELP_DATE_OF_EVENT] = "Se ci sono più date note in cui si è verificato l'evento, compilare un modulo per ogni data.";
translations[DATE_BAXTER_EMPLOYEE] = "Data di notifica dell'evento ad un dipendente Baxter ";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(La data fornita non deve necessariamente coincidere con la data di inserimento delle informazioni.)";
translations[DURING_WHAT_PROCESS] = "Durante quali fasi del processo si è verificato l'evento?";
translations[WAS_THE_PATIENT] = "Il paziente era connesso (trattamento in corso) al momento dell'evento?";
translations[WERE_YOU_CONNECTED] = "Eri connesso (trattamento in corso) al momento dell'evento?";
translations[PROVIDE_ANY_ADDITIONAL] = "Fornire ulteriori dettagli relativi all'evento/problema";
translations[HELP_YOU_IDENTIFIED_MORE] = "Ha identificato più di un prodotto e un problema, chiarire quali prodotti riportano i problemi segnalati.";
translations[ENTER_DETAILS] = "Inserire i dettagli";
translations[PROVIDE_ANY_ATTACHMENT] = "Fornire qualsiasi documentazione che possa essere utile ai fini di ricostruire l'evento in allegato ";
translations[WAS_NEGATIVE_MEDICAL] = "Ci sono stati sintomi avversi, lesioni, ferite o danni al paziente a seguito dell'evento?";
translations[WAS_MEDICAL_INTERVENTION] = "Sono stati forniti trattamenti specifici o interventi medici di assistenza per contrastare l'evento segnalato?";
translations[PROVIDE_DETAILS] = "Fornire i dettagli";
translations[REQUIRED_TREATMENT] = "Trattamento richiesto/intervento medico";
translations[ENTER_TREATMENT] = "Immettere il trattamento utilizzato";
translations[RELEVANT_TESTS] = "Test eseguiti, inclusi i dati di laboratorio:";
translations[HELP_RELEVANT_TESTS] = "Inserire i test pertinenti impiegati ";
translations[RELEVANT_MEDICAL_HISTORY] = "Anamnesi e condizioni mediche preesistenti:";
translations[ENTER_HISTORY] = "Inserire la cronologia / anamnesi ";
translations[PATIENT_NAME] = "Nome del paziente";
translations[PATIENT_INITIALS] = "Inserire le iniziali o il nome del paziente. Se ci sono più pazienti coinvolti, per favore compilare il modulo per ogniuno di loro ";
translations[PATIENT_PHONE_NUMBER] = "Numero di telefono del paziente";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "Non desidero fornire ";
translations[PATIENT_EMAIL_ADDRESS] = "Indirizzo e-mail del paziente";
translations[PATIENT_ADDRESS] = "Indirizzo paziente";
translations[SAME_ADDRESS] = "Stesso indirizzo";
translations[DRUG_BEING_USED] = "Un farmaco Baxter è stato usato al momento dell'evento?";
translations[PATIENT_IDENTIFIER] = "Identificativo del paziente";
translations[PATIENT_AGE_OR_DOB] = "Età del paziente o data di nascita";
translations[ENTER_PATIENT_AGE] = "mm/gg/aaaa, inserire l'età del paziente";
translations[PATIENT_GENDER] = "Genere del paziente";
translations[PATIENT_WEIGHT] = "Peso del paziente";
translations[ENTER_WEIGHT] = "Inserire il peso";
translations[PATIENT_WEIGHT_UNIT] = "Unità di peso del paziente";
translations[MY_NAME] = "Il mio nome";
translations[ENTER_IN_YOUR_CONTACT] = "Inserire le  informazioni relative al tuo contatto";
translations[MY_PHONE_NUMBER] = "Il mio numero di telefono";
translations[MY_EMAIL_ADDRESS] = "Il mio indirizzo e-mail";
translations[MY_ADDRESS] = "Il mio indirizzo";
translations[NAME_OF_BAXTER_DRUG] = "Nome del farmaco Baxter utilizzato";
translations[ENTER_DRUG_NAME] = "Inserire il nome del farmaco";
translations[PLEASE_PROVIDE_THE_NAME] = "Fornisci il nome o il codice prodotto del farmaco Baxter. Fornisci il nome di tutti i farmaci Baxter in uso al momento del problema segnalato";
translations[SELECT_THE_COMPONENT] = "Selezionare il componente che ha avuto il problema";
translations[USE_THE_DIAGRAM] = "Utilizzare il diagramma sovrastante (Figura 1) per determinare il punto in cui il dispositivo è danneggiato ";
translations[TYPE_OF_DAMAGE] = "Descrivere il tipo danno presente ";
translations[PLEASE_ENTER_VALUE] = "Inserire il valore";
translations[WAS_THE_PRODUCT_KINKED] = "Il dispositivo era piegato, incrinato, crepato, tagliato, ecc.?";
translations[WERE_ANY_CLEANING] = "Sul Prodotto sono state utilizzati soluzioni detergenti, solventi o disinfettanti?";
translations[WHAT_WAS_THE_DISINFECTANT] = "Qual è il nome o la marca del disinfettante utilizzato e come è stato utilizzato?";
translations[NOTE_BAXTER_LABELING] = "L'etichetta Baxter indica di non applicare candeggina, perossido di idrogeno, alcool o soluzioni antisettiche contenenti alcool sul set. L'utilizzo di questi prodotti può determinare la formazione di crepe sul prodotto. ";
translations[SELECT_ALL_THAT_APPLY] = "Seleziona tutto ciò che è applicabile";
translations[DID_FOLLOWING_OCCUR] = "Si è verificata una delle seguenti condizioni?";
translations[SELECT_THE_LOCATION] = "Seleziona la posizione del danno sul Minicap";
translations[WAS_THE_PRODUCT_EXPOSED] = "Il prodotto è stato esposto ad una forza eccessiva (ad esempio: sbattuto, urtato, colpito, ecc.) prima che si verificasse il problema?";
translations[HOW_LONG_TRANSFER] = "Da quanto tempo è in uso il set di trasferimento?";
translations[WAS_THERE_DIFFICULTY] = "C'è stata qualche difficoltà durante l'apertura o la chiusura del morsetto a torsione (twist clamp)?";
translations[WAS_DEVICE_OR_TOOL] = "È stato utilizzato un dispositivo o uno strumento per aprire o chiudere il morsetto a torsione (twist clamp)?";
translations[DESCRIBE_HOW_PRODUCT] = "Descrivi come il prodotto è stato difficile da usare (selezionare tutto ciò che è applicabile)";
translations[DID_YOU_OBSERVE] = "Hai osservato eventuali danni (ad esempio tagli, fori, crepe) presenti nel prodotto?";
translations[WERE_DIFFICULTIES_PUTTING] = "Ci sono state difficoltà nell'inserire il Minicap sul set di trasferimento e ruotarlo in senso orario fino a quando non si è saldato in modo sicuro?";
translations[WAS_THE_TRANSFER] = "Il set di trasferimento è stato sostituito a causa di questo evento?";
translations[SELECT_TYPE_OF_FLOW] = "Selezionare il tipo di problema del flusso";
translations[WAS_ANYTHING_BLOCKING] = "C'era qualcosa che ostruiva il flusso?";
translations[WAS_ANY_ALARM] = "C'è stato un allarme?";
translations[SELECT_BEST_DESCRIBE] = "Selezionare l'opzione che meglio descrive il problema";
translations[WERE_THE_MINICAPS] = "I Minicaps sono stati esposti a sbalzi temirci?";
translations[WAS_THE_SPONGE_VISIBLE] = "La spugna era visibile all'interno del Minicap?";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "In che punto si trova il particolato/materiale estraneo?";
translations[DESCRIBE_THE_EXACT_LOCATION] = "Descrivere la posizione esatta in cui è stato riscontrato, le dimensioni, la forma e il colore del particolato/materiale estraneo:";
translations[WAS_THE_PARTICULATE_MATTER] = "Il particolato/materiale estraneo risulta essere incorporato nel prodotto?";
translations[DOES_THE_PARTICULATE_MATER] = "Il particolato mater/materiale estraneo risulta essere parte del materiale con cui è stato prodotto il dispositivo?";
translations[WHAT_COMPONENT_DOES] = "In quale componente si trova il particolato?";
translations[SELECT_CONNECTION_ISSUE] = "Selezionare l'opzione che meglio descrive il problema di connessione";
translations[WERE_ASSIST_DEVICES] = "Sono stati utilizzati dispositivi di assistenza o degli strumenti per garantire la connessione del disposable?";
translations[WERE_ANY_DIFFICULTIES] = "La connessione iniziale o la disconnessione sono state difficoltose?";
translations[PROVIDE_PRODUCT_INFORMATION] = "Fornire le informazioni sul secondo prodotto coinvolto nel problema di connessione";
translations[WERE_THE_SPIKE_LUER] = "I connettori spike/luer sono stati ruotati in senso orario fino a quando sono risultati fissati saldamente?";
translations[BAXTER_LABELING_STATES] = "L'etichetta Baxter indica di assicurarsi che tutte le connessioni del dispositivo monouso siano ben salde e strette prima di iniziare la terapia.";
translations[WERE_PETS_OR_ANIMALS] = "C'erano animali domestici o altri animali che potrebbero aver danneggiato il set usa e getta?";
translations[BAXTER_LABELING_CONTAMINATION] = "L'etichetta Baxter indica che può evvinire una contaminazione nel percorso fluido se un animale morde il dispositivo medico usa e getta. Per ridurre il rischio di contaminazioni, non eseguire la dialisi nella stessa stanza in cui si trovano animali domestici.";
translations[WERE_OTHER_ISSUES] = "Ci sono stati altri problemi o difficoltà associati al spike/luer (cioè danneggiato, rotto, incrinato, deformato, piegato ecc.)?";
translations[WAS_MINICAP_TWISTED] = "Il Minicap è stato avvitato in senso orario sul connettore del set di trasferimento fino a quando non è saldamente fissato?";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "Sono state riscontrate difficoltà a mettere il Minicap sul set di trasferimento?";
translations[DID_TRANSFER_SET_CONNECTORS] = "I connettori del set di trasferimento hanno difetti visibili o presentano le filettature danneggiate? ";
translations[WHAT_WAS_THE_ALARM] = "Qual era l'allarme presenti?";
translations[WHERE_OBSERVED_DAMAGE] = "Dov'è stato osservato il danno? (seleziona tutto ciò che è applicabile)";
translations[SELECT_THE_TYPE_OBSERVED] = "Seleziona il tipo di danno osservato (seleziona tutto ciò che è applicabile)";
translations[DID_DAMAGE_CAUSE_LEAK] = "Il danno osservato ha causato una perdita?";
translations[WAS_THE_SHIPPING_CARTON] = "Il cartone di spedizione è stato aperto con un oggetto appuntito?";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "Selezionare il tipo di problema di flusso osservato";
translations[HOW_LONG_WAS_STORAGE] = "Quanto tempo è rimasto in magazzino il prodotto prima che venisse trovato scaduto?";
translations[WAS_THERE_AN_ADAPTER] = "È stato utilizzato un adattatore o altro dispositivo assieme al prodotto?";
translations[NAME_AND_MODEL] = "Qual è il nome e il modello dell'adattatore o dell'altro dispositivo utilizzato con il prodotto?";
translations[NAME_VAPORIZER] = "Qual è il nome e il modello del vaporizzatore?";
translations[WAS_VIAL_INVERTED] = "Il flaconcino attaccato è stato invertito prima di aver somministrato la soluzione nel flaconcino?";
translations[WHAT_VIAL_USED] = "Quali sono le informazioni sul prodotto per il flaconcino utilizzato?";
translations[DRUG_NAME_MANUFACTURER] = "Nome del farmaco, produttore, dimensioni del flaconcino";
translations[WERE_BREAK_FRANGIBLE] = "E' stato possibile rompere correttamente il frangibile usando un movimento avanti e indietro?";
translations[WAS_ALARM_ASSOCIATED] = "C'è stato un allarme associato all'assenza di flusso?";
translations[WHAT_PART_DISCOLORED] = "Quale parte del prodotto è riportato scolorito? (seleziona tutto ciò che è applicabile)";
translations[DESCRIBE_DISCOLORATION] = "Descrivere lo scolorimento (descrivere il colore, la sfumatura, la tonalità, ecc.):";
translations[HOW_PRODUCT_STORED] = "Come è stato conservato il prodotto?";
translations[DOES_DISCOLORATION_APPEAR] = "Lo scolorimento segnalato sembra essere opaco, nebbioso, torbido e/o presenta segni circolari/a nido d'ape?";
translations[WHICH_CHAMBER_DISCOLORED] = "Quale camera era scolorita sulla sacca?";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "La guarnizione che è può essere staccata o l'intercamera frangibile erano già rotte o attivate?";
translations[WAS_DISCOLORATION_NOTICED] = "Lo scolorimento è stato notato attraverso il vetro del vaporizzatore?";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "Selezionare l'opzione che descrive in modo più specifico il problema:";
translations[WHAT_DEVICE_HAD_ALARM] = "Quale dispositivo ha emesso l'allarme?";
translations[WHAT_MISSING_MISASSEMBLED] = "Quale componente mancava o era smontato?";
translations[RECONSTITUTION_ISSUE] = "Fornire una descrizione più specifica del problema riscontrato nella ricostituzione ";
translations[WHAT_MEDICATION_SOLUTION] = "Con quale farmaco o soluzione è stato ricostituito il prodotto?";
translations[WHAT_VOLUME_MEDICATION] = "Qual è stato il volume di farmaco o soluzione utilizzato per ricostituire?";
translations[WHAT_DEVICES_RECONSTITUTION] = "Quali altri dispositivi sono stati utilizzati durante la ricostituzione (nome/produttore, dimensione/calibro dell'ago, ecc.)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "Il prodotto è stato esposto al calore?";
translations[DESCRIBE_EXPOSURE] = "Descrivere l'esposizione (temperatura, per quanto tempo, ecc.)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "Quale tecnica è stata utilizzata per attivare la soluzione?";
translations[WAS_DAMAGE_OBSERVED] = "Si sono verificati dei danni al prodotto prima dell'attivazione?";
translations[DESCRIBE_THE_DAMAGE] = "Descrivere il danno:";
translations[APPROXIMATELY_SOLUTION_POWDER] = "Approssimativamente, quanta soluzione o polvere mancava o è stata riempita troppo rispetto al prodotto finale?";
translations[WAS_LEAK_OBSERVED] = "C'è stata qualche perdita?";
translations[WHAT_FEATUR_DIFFICULT_USE] = "Quale componente del prodotto è difficile da usare?";
translations[HOW_WAS_DIFFICULT_USE] = "In che modo il prodotto è difficile da usare?";
translations[WHERE_MATTER_FOREIGN] = "Dove si trovava il particolato/materiale estraneo?";
translations[DOES_PARTICULATE_MATTER] = "Il particolato/materiale estraneo sembra essere parte del materiale che costituisce il prodotto?";
translations[DESCRIBE_EXACT_LOCATION] = "Descrivere la posizione esatta, il colore, le dimensioni, la forma e la consistenza del particolato/materiale estraneo:";
translations[WAS_MATTER_FOREIGN] = "Il particolato/materiale estraneo è stato incorporato nel prodotto (non liberamente in movimento)?";
translations[WHEN_MATTER_FOREIGN] = "Quando è stata osservato il particolato/materiale estraneo?";
translations[PROVIDE_INFORMATION_MEDICATION] = "Fornire informazioni specifiche sul farmaco aggiunto:";
translations[PRODUCT_NAME_CODE_NUMBER] = "Nome del prodotto, codice del prodotto, numero del lotto del prodotto, nome del marchio ";
translations[DESCRIBE_SPIKING] = "Descrivere la tecnica di spiking o ricostituzione utilizzata:";
translations[INCLUDE_NEEDLE] = "Includere la misura o il calibro dell'ago, angolo di inclinazione dell'iniezione, numero di tentativi";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "Quale set di amministrazione o dispositivo di ricostituzione è stato utilizzato?";
translations[INCLUDE_MANUFACTURER] = "Includere il nome del produttore, nome del prodotto, codice del prodotto, lotto del prodotto";
translations[WAS_MEDICATION_ADDITIVE] = "Al prodotto è stato aggiunto un farmaco, un additivo o una soluzione di ricostituzione?";
translations[WHAT_MEDICATION_ADDITIVE] = "Quale farmaco, additivo o soluzione di ricostituzione è stato aggiunto?";
translations[WHAT_STATE_OF_PRODUCT] = "Qual era lo stato del prodotto quando si è stata osservata la torbidità o il precipitato?";
translations[AFTER_UNITS_SAT] = "Dopo che il prodotto è stato costituito e ha raggiunto la temperatura ambiente, la torbidità e il precipitato sono spariti?";
translations[DID_ATTEMPT_AGITATE] = "Hai tentato di agitare il prodotto finito?";
translations[DID_PRECIPITATE_DISSOLVE] = "Il precipitato si è sciolto?";
translations[WHAT_STORAGE_TEMPERATURE] = "Quali erano la temperatura e le condizioni di conservazione del prodotto?";
translations[PROVIDE_TEMPERATURE_LOCATION] = "Fornire temperatura, e la posizione in cui è stato conservato il dispositivo medico: sinvolucro interno o esterno della confezione primaria/del cartone, in VSC/cartone intermedio, o unità individuali";
translations[ARE_TEMPERATURE_LOGS] = "Sono disponibili registri di temperatura del congelatore in cui il prodotto è stato conservato?";
translations[LOGS_CAN_BE_ATTACHED] = "I registri dei Log file possono essere allegati direttamente a questo modulo, se disponibili al momento della sottimissione del reclamo";
translations[IS_THE_STORAGE_UNIT] = "L'unità di stoccaggio (congelatore o frigorifero) è calibrato e a temperatura controllata?";
translations[HOW_PRODUCT_THAWED] = "Come è stato scongelato il prodotto?";
translations[WHAT_STORAGE_CONDITIONS] = "Quali erano le condizioni di conservazione del prodotto? (temperatura, posizione, conservato all'interno o all'esterno della confezione  secondaria/cartone)";
translations[WAS_ANY_DAMAGE] = "Sono stati osservati problemi o danni al prodotto?";
translations[MORE_SPECIFIC_INFORMATION] = "Fornire informazioni più specifiche:";
translations[WHAT_PURPOSE_INDICATION] = "Qual era l'indicazione riguardo al trattamento per il paziente? A che scopo?";
translations[WHAT_ROUTE_ADMINISTRATION] = "Quale era la via di amministrazione?";
translations[WHAT_DATE_ADMINISTRATION] = "Quando è avvenuta la amministrazione e quanto è durata?";
translations[WHAT_DOSAGE_STRENGTH] = "Quale è stato il dosaggio e la forza somministrato al paziente?";
translations[WAS_RECENT_PRESCRIPTION] = "Il paziente aveva subito recentemente un cambiamento nella prescrizione?";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "Quali erano i dettagli di stoccaggio e di temperatura del prodotto (posizione di stoccaggio/frigorifero/congelatore, ecc.)?";
translations[WERE_ANY_ADJUSTMENTS] = "Sono state apportate modifiche alla soluzione o aggiunti additivi prima della somministrazione?";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "Selezionare la descrizione più appropriata del problema:";
translations[SELECT_LABELING_ISSUE] = "Selezionare la descrizione più appropriata del problema di etichettatura:";
translations[WAS_CONNECTION_SECURE] = "La connessione era sicura e completamente serrata?";
translations[WAS_EXPIRED_PRODUCT] = "Il prodotto scaduto è stato somministrato al paziente?";
translations[WAS_COMPONENT_DAMAGED] = "Qualche componente è risultato danneggiato?";
translations[WERE_ABNORMALITIES_DAMAGE] = "Sono state riscontrate anomalie o danni al prodotto?";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "Quale è il codice dell'ordine di acquisto?";
translations[WHAT_DATE_OF_ADMINISTRATION] = "In che data è avvenuta la somministrazione?";
translations[WHAT_WAS_EXPIRATION_DATE] = "Quale è la data di scadenza del prodotto?";
translations[DESCRIBE_WAS_INCORRECT] = "Descrivere che cosa non era corretto, incompleto, mancante, illeggibile nell'etichetta o cosa era troppo simile (a un altro prodotto) sull'etichetta:";
translations[WHAT_SCANNER_USED] = "Che tipo di scanner è stato utilizzato?";
translations[WAS_OVERPOUCH_POUCH] = "Il prodotto era ancora nella sua confezione durante la scansione?";
translations[WHAT_BACKGROUND_COLOR] = "Qual era il colore di sfondo durante la scansione?";
translations[DO_ALL_OF_THE_LABELS] = "Tutte le etichette (prodotto, scatola/cartone, spedizione/distribuzione) hanno le stesse informazioni sul prodotto?";
translations[PRODUCT_INFORMATION] = "Informazioni sul prodotto";
translations[IS_A_BARCODE_SCANNER] = "Uno scanner per  codici a barre viene utilizzato presso la tua struttura?";
translations[HOW_ARE_THESE_PRODUCTS] = "Come vengono conservati questi prodotti nella struttura?";
translations[WHAT_INFORMATION_INCORRECTLY] = "Quali informazioni sono state visualizzate in modo errato durante la scansione?";
translations[WAS_THERE_LEAK] = "È stata osservata una perdita?";
translations[WHERE_LEAK_OBSERVED] = "Dove è stata osservata la perdita, quale componente stava perdendo?";
translations[WAS_FRANGIBLE_OBSERVED] = "Il frangibile è stato trovato rotto?";
translations[IS_MOISTURE_CLEAR] = "La soluzione è limpida?";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "Chi è il tuo distributore?";
translations[WHAT_MANUFACTURER_MEDICATION] = "Quale è il nome del produttore, il nome del farmaco e le dimensioni del flaconcino utilizzati?";
translations[WHAT_GAUGE_NEEDLE] = "Quale è il calibro dell'ago utilizzato, il produttore e il numero di volte che il sito è stato perforato?";
translations[WHAT_ADMINISTRATION_SET] = "Quale set di amministrazione è stato utilizzato?";
translations[WAS_DIFFICULTY_SPIKING] = "E' stata riscontrata difficoltà nell'iniezione?";
translations[WERE_FOLLOWING_SCENARIOS] = "Si è verificato uno dei seguenti scenari dopo la perdita?";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "Sono stati osservati danni o difetti nel frangibile?";
translations[WHAT_AMOUNT_PRESSURE] = "Che pressione è stata applicata e per quale durata?";
translations[WAS_BAG_COMPLETELY] = "La sacca è stata inserita completamente e correttamente nel  misuratore di pressione (pressure cuff)? Un'estremità era rimasta sconnessa?";
translations[WHAT_MANUFACTURER_MODEL] = "Qual è il produttore, il modello e le dimensioni del dispositivo misuratore della pressione (pressure cuff)?";
translations[WHAT_PRESSURE_PRIOR] = "Qual'era la pressione impostata prima che venisse rilevata la perdita?";
translations[LIST_THE_VAPORIZER] = "Elenca il produttore del vaporizzatore e il nome/modello";
translations[APPROXIMATELY_HOW_MUCH] = "Approssimativamente quanto liquido è stato versato?";
translations[WAS_THE_BOTTLE_DIFFICULT] = "E' stato difficile inserire la bottiglia nel vaporizzatore?";
translations[WERE_VISIBLE_DEFECTS] = "C'erano difetti visibili?";
translations[SELECT_THE_OPTION] = "Selezionare l'opzione che meglio descrive il problema di connessione";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "Fornire le informazioni sul secondo prodotto coinvolto nel problema di connessione";
translations[WHICH_PART_SEPARATED] = "Quali parti del prodotto si sono separati?";
translations[WHAT_COMPONENT_DISCOLORED] = "Quale componente è scolorito?";
translations[SELECT_DESCRIBES_DISCOLORATION] = "Seleziona l'opzione che meglio descrive lo scolorimento:";
translations[WAS_THE_SET_DISCOLORED] = "Il set appariva già scolorito quando è stato rimosso dalla confezione?";
translations[DID_SET_CHANGE_COLOR] = "Il set ha cambiato colore dopo aver aggiunto farmaci?";
translations[WHAT_MEDICATION_ADDED] = "Quale farmaco è stato aggiunto prima del cambiamento di colore?";
translations[WHERE_MATERIAL_LOCATED] = "Dove si trovava il particolato/materiale estraneo?";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "Descrivere il particolato/materiale estraneo (aspetto/colore/dimensione):";
translations[WAS_EMBEDDED_PLASTIC] = "Il particolato/materiale estraneo era sciolto o incorporato nella plastica?";
translations[WAS_THERE_A_PRECIPITATE] = "C'è stato un precipitato o un cambiamento di colore delle soluzione che non era previsto?";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "Quali farmaci/soluzioni sono stati infusi attraverso il set?";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "Dove si è riscontrato il danno o quali componenti erano  interessati? (selezionare tutto ciò che è applicabile)";
translations[WHAT_DAMAGE_ISSUE] = "Che tipo di danno/problema è stato osservato? (selezionare tutto ciò che è applicabile)";
translations[DID_ISSUE_RESULT] = "Il problema segnalato ha provocato una perdita?";
translations[WAS_PATIENT_CONNECTED] = "Il paziente era collegato al prodotto?";
translations[WAS_PRODUCT_REPLACED] = "Il prodotto era stato sostituito con un nuovo prodotto?";
translations[WHICH_SITUATION_BEST] = "Quale situazione descrive meglio il problema di separazione/connessione";
translations[SELECT_MOST_LABELING_ISSUE] = "Selezionare la descrizione più appropriata del problema di etichettatura:";
translations[WHAT_INFORMATION_DISPLAYED] = "Quali informazioni sono state mostrate?";
translations[WHAT_SCANNER_WAS_USED] = "Che tipo di scanner è stato utilizzato?";
translations[INCLUDE_THE_MODEL_NAME] = "Includere il nome del modello";
translations[WAS_PRODUCT_ORDERED] = "Il prodotto è stato ordinato direttamente da Baxter o da un altro distributore?";
translations[WHERE_LEAK_COMING] = "Da dove proveniva la perdita? (seleziona tutto ciò che è applicabile)";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "Si è verificato uno dei seguenti scenari con la perdita?";
translations[WAS_POWER_INJECTOR] = "Il prodotto è stato utilizzato con un iniettore alimentato a batteria?";
translations[WHAT_INJECTOR_USED] = "Quale iniettore alimentato a batteria è stato utilizzato?";
translations[MANUFACTURER_NAME_CODE_LOT] = "Produttore, nome del prodotto, codice del prodotto, lotto del prodotto";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "Descrivi cosa non era corretto, incompleto, mancante, illeggibile o è cambiato sull'etichetta:";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "Fornire le informazioni riguardanti il secondo prodotto coinvolto nella disconnessione";
translations[WHICH_COMPONENTS_WERE_FOUND] = "Quali componenti hanno crepa o appaiono rotti?";
translations[DESCRIBE_CUT_HOLE_SLICE] = "Descrivere la posizione esatta sul tubo che presenta il taglio, o il foro ";
translations[WAS_LEAK_ORIGINATING] = "La perdita è stata originata dall'apertura del sito di iniezione";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "Fornire le informazioni riguardanti il secondo prodotto coinvolto nella disconnessione";
translations[WHICH_SPECIFIC_BONDED] = "Quali componenti che dovrebbero essere collegati sono stati trovati separati?";
translations[WERE_VISIBLE_IRREGULARITIES] = "Sono presenti irregolarità/danni visibili sul prodotto/i e sui componenti coinvolti?";
translations[WAS_SUCCESSFUL_CONNECTION] = "E' stato possibile connettere o disconnettere fino ad ottenere la configurazione ottimale (senza dover sostituire il prodotto)?";
translations[WAS_TOOL_USED_ASSIST] = "È stato utilizzato uno strumento per assistere la connessione/disconnessione?";
translations[WERE_LUER_CONNECTIONS] = "Tutte le connessioni Luer sono state controllate per assicurarsi che fossero ben salde prima dell'uso (come indicato dall'etichetta)";
translations[WAS_PRODUCT_SECURELY] = "Il prodotto è stato collegato in modo sicuro e stretto con un altro prodotto prima della disconnessione?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "Quale situazione descrive meglio il problema relativo al flusso?";
translations[WHAT_FLOWING_BACKWARDS] = "Cosa scorreva in senso opposto?";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "Descrivi i componenti da dove è iniziato il flusso in senso opposto fino al punto in cui si è fermato";
translations[DO_SITUATIONS_APPLY] = "Alcune delle seguenti situazioni si applicano all'evento riportato?";
translations[WHICH_SPECIFIC_AREA] = "Quale area specifica del set o del componente è  associata ai problemi di flusso?";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "Il flusso è stato visto in precedenza attraverso il set o ad un componente?";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "È stato osservata una delle seguenti situazioni:";
translations[WHERE_SIMULTANEOUS_FLOW] = "Dove si è riscontrato flusso simultaneo?";
translations[WHAT_TYPE_HANGER] = "Che tipo di gancio è stato utilizzato?";
translations[WHAT_WAS_HANGER_LENGTH] = "Qual era la lunghezza del gancio e/o il produttore?";
translations[WHICH_BAG_LOWER] = "Quale sacca era posizionata più in basso?";
translations[WHAT_Y_SITE_WAS] = "A quale connessione a Y era collegato il set secondario?";
translations[WHAT_COMPONENT_WITHIN] = "Quale componente all'interno del set non può essere pulito dal sangue?";
translations[WAS_COMPONENT_SET_REPLACED] = "Il componente/set è stato sostituito dopo che non è stato possibile pulirlo dal sangue?";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "Qual'era il volume di liquido da infondere al paziente e per quanto tempo come da prescrizione? ";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "Quale è stato il volume di fluido effettivamente infuso nel paziente e in quanto tempo?";
translations[WAS_USED_WITH_PUMP] = "Il set è stato usato con una pompa?";
translations[DID_CLAMP_FAIL] = "La clamp ha fallito nel fermare o nel controllare il flusso?";
translations[WHAT_CLAMP_FAILED] = "Quale clamp ha fallito?";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "Sono stati osservati problemi con la clamp?";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "Alcune di queste altre situazioni descrivono il problema presente sul prodotto? (seleziona tutto ciò che è applicabile)";
translations[DESCRIBE_ALARM_OBSERVED] = "Descrivi l'allarme osservato:";
translations[INCLUDE_ANY_MESSAGES] = "Includere i messaggi e i codici di errore associati all'allarme della macchina ";
translations[WHICH_CLAMP_HAD_ISSUE] = "Quale clamp presenta il problema?";
translations[WHICH_TYPE_CLAMP_ISSUE] = "Quale tipo di problema è stato riscontrato? (selezionare tutto ciò che è applicabile)";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "Selezionare lo scenario che meglio descrive il problema:";
translations[PROVIDE_MORE_DETAILS] = "Fornire ulteriori dettagli sul motivo relativo al difficile utilizzo del prodotto";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "Fornire ulteriori dettagli sulle istruzioni difficili da seguire/capire:";
translations[DESCRIBE_THE_SMELL] = "Descrivere l'odore e da dove proviene:";
translations[WAS_ISSUES_WITH_SET] = "Sono stati osservati problemi con il set?";
translations[WHERE_LEAK_LOCATED] = "In che punto sul prodotto si è osservata la perdita?";
translations[DID_OCCUR_WITH_LEAK] = "Con la perdita si è verificata una delle seguenti situazioni?";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "Fornire le informazioni riguardanti il secondo prodotto coinvolto nella disconnessione";
translations[DID_OCCURRED_WITH_THE_LEAK] = "Si è verificato uno dei seguenti scenari con la perdita?";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "Dove è stato danneggiato il prodotto?";
translations[SELECT_ALL_APPLY] = "Seleziona tutto ciò che è applicabile";
translations[DESCRIBE_OBSERVED_DAMAGE] = "Descrivere il danno osservato";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "Quale componente del prodotto è scolorito?";
translations[DESCRIBE_HUE_TINT_SHADE] = "Descrivere il colore osservato (tonalità, tinta, ecc.):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "All'interno o all'esterno dell'involucro del packaging, temperatura, esposizione alla luce, ecc.";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "Descrivere la posizione esatta in cui è stato riscontrato, le dimensioni, la forma e il colore del particolato/materiale estraneo:";
translations[DOES_THE_PARTICULATE_MATTER] = "Il particolato/materiale estraneo sembra essere parte del materiale con cui è constituito il prodotto?";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "Il particolato/materiale estraneo è incorporato nel prodotto?";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "Il particolato mater/materiale estraneo risulta essere parte del materiale con cui è stato prodotto il dispositivo?";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "Dove si è verificato il problema sul prodotto?";
translations[LIST_COMPONENTS_IF] = "Elencare i componenti presenti. Se è stato coinvolto un secondo prodotto, fornire il produttore, il nome del prodotto, il codice del prodotto, il lotto del prodotto";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "Sono state osservate irregolarità/danni visibili?";
translations[SELECT_OPTION_FLOW_ISSUE] = "Seleziona l'opzione che meglio descrive il problema relativo al flusso";
translations[DESCRIBE_IRREGULARITIES] = "Descrivere le irregolarità e i danni presenti sul dispositivo e se è stato osservato un danno prima della connessione o della disconnessione o se si è verificato durante la connessione o la disconnessione";
translations[HOW_PRODUCT_SETUP] = "Come era la configurazione del set del prodotto?";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "Seleziona la descrizione più appropriata relativa al problema di etichettatura:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "Descrivere che cosa non era corretto, incompleto, mancante, illeggibile nell'etichetta o cosa era troppo simile (a un altro prodotto) sull'etichetta:";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "Il prodotto all'interno della confezione di spedizione è stato danneggiato?";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "Quale prodotto doveva essere ricevuto?";
translations[IF_PRODUCT_CODE_NOT] = "Se il codice del prodotto non è disponibile, fornire la descrizione del prodotto";
translations[WAS_THE_CASE_MISSING] = "Giaccio secco o gel pack refrigerati mancavano dal case?";
translations[WHAT_CARRIER_DELIVERED] = "Quale corriere ha consegnato il prodotto?";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "Qual è il codice d'acquisto dell'ordine?";
translations[WHAT_QUANTITY_MISSING_UNITS] = "Qual era la quantità dei prodotti mancanti?";
translations[WAS_EXPIRED_PRODUCT_USE] = "E' stato usato un prodotto scaduto?";
translations[APPLY_TO_EACH_UNIT] = "Se il problema è avvenuto tra più di una unità, le domande successive si rivolgono ad ogni unità coinvolta";
translations[TERMS_CONDITIONS] = "Termini e condizioni d'utilizzo";
translations[PRIVACY_POLICY] = "Informativa sulla Privacy";
translations[PRIVACY_NOTICE] = "Informativa sulla Privacy";
translations[COOKIE_POLICY] = "Informativa sui Cookie";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "Chiesto ma sconosciuto";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "Dipendente Baxter";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "Chi effettua le cure (caregiver)";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "Distributore";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "Operatore sanitario";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "Paziente";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "Altro";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "Dopo l'uso";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "Prima dell'uso";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "Durante il setup/preparazione/formulazione";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "Durante la terapia";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "Passaggi multipli";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "Non specificato";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membro della famiglia";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "Infermiere";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Infermiere professionista";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Altro operatore sanitario";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "Medico";
translations[OPTION_UNITOPTIONS_BOXES] = "Scatole";
translations[OPTION_UNITOPTIONS_PALLETS] = "Pallet";
translations[OPTION_UNITOPTIONS_UNITS] = "Unità";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "Problema relativo all'allarme";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "Danneggiato";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "Difficile da utilizzare ";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "Scolorito";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "Problemi di flusso";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "Problemi relativi all'etichettatura ";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "Perdite / Umidità eccessiva";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "Particolato / Materiale estraneo";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "Reazione del paziente / Evento avverso ";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "Domanda sul prodotto ";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "Separazione / Connessione";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "Problemi relativi alla spedizione / Prodotto scaduto ";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "Femmina";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "Indifferenziato";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "Maschio";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "Rifiuta di rispondere";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "Amministratore/Supervisore ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "Ingegnere biomedico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "Rappresentante dell'azienda ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "Dentista";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "Distributore";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "Membro della famiglia";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "Lay User";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "Infermiere";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "Infermiere professionista";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "Altro operatore sanitario";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "Farmacista";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "Farmacista preparatore ospedaliero";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "Medico";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "Paziente";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "Responsabile del rischio";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "Altro";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "Contattare la persona aggiuntiva";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "Contattami";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "Contatto Altro";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "Baxter";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "Cina FDA";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "FDA";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "Health Canada";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (Giappone)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (Australia)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "Un animale domestico potrebbe aver causato il problema";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "Un oggetto o uno strumento appuntito è stato utilizzato per aprire il cartone o la confezione esterna";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "Il prodotto era esposto a una forza eccessiva (ad esempio, sbattuto, urtato, colpito, ecc.) prima che si verificasse il problema";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "Il prodotto era esposto o conservato in un ambiente caldo/freddo";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "Cartone";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "Minicap";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "Confezione primaria ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "Il set di trasferimento era troppo stretto";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "Il set di trasferimento era troppo allentato.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "Il set di trasferimento non era in grado di chiudersi completamente.";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "Il set di trasferimento non era in  grado di aprirsi completamente. ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "Il morsetto a torsione (twist clamp( era così stretto che il transfer set non si riusciva ad aprire ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "Il morsetto a torsione (twist clamp( era così stretto che il transfer set non si riusciva a chiudere ";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "Sì, c'era un danneggiamento a livello della filettature del set di trasferimento che non faceva in modo che si chiudesse correttamente ";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "Sì, il Minicap è stato chiuso in modo accessivo al set di trasferimento a mano o con un utensile/dispositivo di assistenza";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "Completamente bloccato, assenza di  flusso di fluido";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "Limitato o parzialmente scorrevole (flusso lento)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "Sangue coagulato";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "Fibrina ";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "Piegatura accentuata";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "Particolato";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "Materiale";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "Eccesso di iodio (marrone) identificato al momento del collegamento o nella confezione ";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "Umidità in eccesso (gocce trasparenti) identificata nella confezione";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "Rivestimento della confezione danneggiata prima dell'apertura";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "Confezione/scatola aperta o danneggiata prima dell'uso";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "Spugna essiccata e bianca";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "Spugna essiccata con un colore brunastro ";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "All'interno dell'imballaggio secondario";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "All'interno del prodotto/o del percorso fluido";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "Sull'esterno del cartone di spedizione";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "Sull'esterno del prodotto";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "All'interno del cartone di spedizione";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Sull'esterno del cartone di spedizione";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficoltà nel collegamento del prodotto a un altro prodotto";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficoltà di scollegamento del prodotto da un altro prodotto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separazione dei componenti in un singolo prodotto";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separazione/disconnessione del prodotto da un altro prodotto";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "Si - residuo sui fili";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "SI - danneggiamento visibile";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "Sì - Altro (testo libero)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangibile";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Foro per appendere la sacca";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Punto di iniezione, inserimento";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membrana punto accesso ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "Confezionamento secondario";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Patch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Tappo in gomma (stopper)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Cartone di spedizione";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Confezione protettiva del tappo";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Contenitore della soluzione";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Protettore dell'ago o dell'oggetto appuntito ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Pellicola chiusa in modo temperato ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "Strappato";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "Incrinato";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "Piegato";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "Tagliato";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "Deformato";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "Fuso";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "Foro";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "Piegato in modo irreversibile";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "Sciolto";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "Strati separati";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "Vetro frantumato ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "Rotto";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "Attorcigliato";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "La soluzione non scorrere affatto";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "La soluzione scorrere molto lentamente";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "La soluzione non scorre (o scorre lentamente) durante la ricostituzione o la formulazione";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "Bottiglia";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "Contenitore";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "Foro per appendere la sacca";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "Liner";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "Confezionamento secondario";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "Indicatore dell'ossigeno";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "Patch";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "Accesso ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "Soluzione";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Protettore dell'ago / oggetto accuminato";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "Camera Aminoacidi ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "Camera con destrosio ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "Camera Lipidica ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "Camera Inferiore";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "Camera Superiore";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "Sigillo rotto o scoppiato";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "Prodotto assemblato in modo sbagliato o parzialmente";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "Componente mancante";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "Componenti che dovrebbero essere attaccati separati/disconnessi";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "Prodotto sovrariempito";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "Prodotto sotto riempimento";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "Problema di ricostituzione";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "All'interno dell'imballaggio secondario";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "All'interno del cartone di spedizione";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "Sull'esterno del cartone di spedizione";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "Soluzione interna/ nel percorso fluido";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "All'interno della coppa del vaporizzatore (vetro)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "Sulla superficie esterna del prodotto";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "All'esterno dell'imballaggio secondario";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "Sull'assorbitore di ossigeno";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "Sul cerotto transdermico";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangibile";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Particelle di vetro ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Accesso";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Tappo di gomma (stopper) ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tappo";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "Dopo l'aggiunta di un altro farmaco o dopo la ricostituzione (flaconcini)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "Prima della perforazione o della ricostituzione";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "Freddo (scongelato ma non ancora a temperatura ambiente)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "Congelato";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "Parzialmente scongelato (cristalli di ghiaccio in soluzione) ";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "Temperatura ambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "Baxter Thawing Unit (BTU) - unità di scongelamento Baxter  ";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "Lasciato a temperature ambiente";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "Congelatore";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "Sì - ci sono  prove di danni durante la spedizione";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "Sì - è stata osservata una perdita ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "Sì - c'era un foro o la confezione non sigillata completamente";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "Sì - è stato difficile effettuare lo spiking o ricostituire il prodotto";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "Sì - è stato difficile rompere il frangibile";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "Sì - c'è stata cristallizzazione o precipitazione della soluzione";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "Sì - c'era torbidità e precipitazione nel prodotto Frozen Galaxy";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "Il prodotto non ha fornito l'effetto previsto o è stato inefficace (mancanza di effetto) ";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "Effetto indesiderato/reazione. Specificare: (testo libero)";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "Cartone di spedizione danneggiato durante la consegna del Prodotto";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Prodotto consegnato scaduto";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "Prodotto trovato scaduto";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema al codice a barre -  Informazioni errate visualizzate quando viene scansionato codice a barre";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficoltà nello scannerizzare il bar code / bar code non scannerizzabile";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Prodotto consegnato scaduto";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "Prodotto scaduto trovato nell'inventario ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "Etichetta illeggibile";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Etichetta errata";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Etichetta incompleta ";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "Etichetta troppo simile ad un altro prodotto ";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Le etichette (sul prodotto, sulla scatola di cartone, nella lista di spedizione) non hanno tutte le stesse informazioni sul prodotto";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "Codice a barre mancante";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "Il cartone contiene un prodotto sbagliato o un mix di prodotti sbagliati";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "Cartone di spedizione danneggiato durante la consegna";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Sono state ricevute più unità";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Prodotto consegnato scaduto";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Prodotto trovato scaduto ";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte del cartone è stata aperta o non sigillata";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Informazioni dell'etichetta sul cartone e sull'etichetta di distribuzione non corrispondono al prodotto all'interno del cartone";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "Alcune unità mancano";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "Etichetta mancante ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "Data di scadenza";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "Numero del lotto ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "NDC Numero identificativo del farmaco ";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "Goccioline/ umidità rilevate all'interno dell'involucro secondario senza perdita osservata";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "Perdita";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "Perdita osservata quando la sacca viene spremuta";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "Soluzione che scorre oltre il frangibile";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "Soluzione rilevate all'interno dell'involucro secondario";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "Tra la confezione e il contenitore primario ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "Connessione tra due prodotti";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Contenitore - membrana di accesso / tubo ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Contenitore - punto di iniezione/riempimento";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Contenitore - Foro per il gancio";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "Contenitore";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangibile";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Tappo in gomma (stopper)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Guardinizione di coportura per il tappo";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Protezione per aghi o aggetti accuminati";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Adattatore per il flaconcino ";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "Danni (buchi, strappi) all'imballaggio secondario o al cartone intermedio ";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Esposizione a caldo estremo/ freddo";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Perdita all'interfaccia vaporizzatore";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "Cartone di spedizione aperto con un cutter o oggetto appuntito";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "Animali domestici  (artigliata/masticato)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Sacca di soluzione sottopressione con soluzione sotto pressione con un misuratore di pressione di un altro device";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Acceesso aderente";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "Danni (fori, strappi) all'imballaggio secondario o al cartone intermedio ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "Cartone di spedizione danneggiato durante la spedizione ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "Esposizione a caldo/freddo estremo";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "Perdita all'interfaccia vaporizzatore";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "Apertura del cartone di spedizione con un cutter o un oggetto tagliente";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "Animali domestici  (artigliata/masticato)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "Sacca di soluzione sottopressione con soluzione sotto pressione con un misuratore di pressione di un altro device";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Nessuno dei precedenti";
translations[NO_DESCRIBE_THE_COLOR] = "No - descrivi il colore (testo libero)";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "Superiore a 10mL";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "Meno di 1 mL";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "Bottiglia";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Tappo";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "Valvola/ collo della bottiglia";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "Niente ";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "Difficoltà nel collegamento del prodotto a un altro prodotto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "Difficoltà di scollegamento del prodotto da un altro prodotto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separazione dei componenti in un singolo prodotto";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separazione/disconnessione del prodotto da un altro prodotto";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "Tubo della camera di gocciolamento";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "Tubo";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "Altro - Specificare (testo libero)";
translations[OTHER_PLEASE_SPECIFY] = "Altro - Specificare (testo libero)";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "Bianco/torbido";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "Giallo/Bianco brunastro";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "Altro - Specificare (Testo libero)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "Nell'imballaggio primario/sacchetto blister";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "All'interno del percorso del fluido IV (nel tubo)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "All'interno del cartone di spedizione";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Sull'esterno del cartone di spedizione";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "All'esterno del percorso del fluido IV (esterno del tubo)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "Incorporato";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "Allentato";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "Non applicabile";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "Descrivi il colore (testo libero)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "Sì - Cambia colore";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "Sì - Precipitato";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Sito di accesso";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burette";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Clamp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Camera di gocciolamento";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Tubi";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filtri";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Connettore Luer";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Perforatore";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "Compoenente(i) tagliato/incrinato/rotto";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "Assemblaggio scorretto dei componenti - Specificare (testo libero) ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "Componente(i) piegato/collassato";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "Componenti allentati dentro la confezione";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "Componente (i) malformati/con una forma errata ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "Componente mancante";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "Difficoltà di collegamento del prodotto a un altro prodotto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "Difficoltà a scollegare il prodotto da un altro prodotto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "Connessione allentata";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separazione/disconnessione del prodotto da un altro prodotto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "Separazione tra due componenti incollati in un unico prodotto";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "Impossibile collegare due prodotti insieme";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "Impossibile scollegare il prodotto di un altro prodotto ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema al codice a barre -  Informazioni errate visualizzate quando viene scansionato codice a barre";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "Cambiamenti nella etichetta";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficoltà nella scansione / Codice a barre che non si scansiona";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "Prodotto scaduto ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "Informazioni errate sull'etichetta ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "Codice a barre mancante / mancante UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "Informazioni mancanti sull'etichetta";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "Prodotto senza informazione della data di scadenza";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "Sbavature dell'etichetta / etichetta illeggibile";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "La scatola contiene un prodotto o un insieme di prodotti sbagliati";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "Cartone di spedizione danneggiato durante la consegna";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "Prodotto consegnato scaduto";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "Prodotto trovato scaduto ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "Baxter ";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "Distributore";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "Sono state ricevute più unità";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "Parte del cartone aperto o non sigillato";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "Le informazioni sull'etichetta sul cartone e sulla etichetta di distribuzione non corrispondono con il prodotto nel cartone";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "Mancano alcune unità ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Sito di accesso";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Valvola per l'aria";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burette";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Tappo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Sito di iniezione clearlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Clamp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Camera di gocciolamento";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filtri";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Sito di iniezione interlink";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Connettore luer";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Perforatore";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tubi";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "Perdita tra il sito di iniezione il tubo";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Sito di iniezione per ago";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "Sito di iniezione one-link";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Altro sito di iniezioen (testo libero)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "Crepa/rottura tra componenti rigidi";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "Tagli su tubi morbidi";
translations[DISCONNECTION_OF_CONNECTABLE] = "Disconnessione di collegamenti collegabili/prodotti collegati";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Disconnessione di collegamenti collegabili/prodotti collegati";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "Separazione tra componenti incollati";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "Sì - Descrivi irregolarità/danni (testo libero)";
translations[YES_SPECIFY_THE_TOOL] = "Sì - Specificare lo strumento utilizzato (testo libero)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "Riflusso";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "Problemi clamp: difficile da usare, ma chiude";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "Problemi clamp: la clamp non chiude completamente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "Problemi clamp: la clamp non si apre o è difficile da aprire";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "Nessun flusso";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "Maggiore infusione del necessario";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "Flusso limitato/lento";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "Flusso simultaneo";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "Impossibile pulire il componente";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "Impossibile eseguire il priming";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "Minore infusione del necessario";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "Sangue del paziente (non è stata eseguita trasfusione)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "Soluzioni/trafusione di sangue e derivati sanguigni";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "Perdita dovuta a danneggiamento o buco";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "Disconnessione";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "Perdita";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "Il farmaco è stato somministrato sotto pressione Siringa per infusione pressurizzata o la pompa IV intravenosa";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "La sacca secondaria era in posizione inferiore alla sacca primaria ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "La sacca secondaria era alla stessa altezza della secca primaria";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "Sangue coagulato";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "Non è stato possibile lavare il catetere prima di attaccarlo al set";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "Tubo piegato irreversibilmente";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "Tubo/ sito di iniezione bloccato";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Contenitore primario e secondario (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Due o più conduttori scorrono in un set multi-conduttore";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Due set di somministrazione ciascuno con la propria pompa per infusione";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "Gancio Baxter";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "Gancio non Baxter ";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "Le sacche erano alla stessa altezza";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "Primario";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "Secondario";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "Medio";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "Inferiore";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "Superiore";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "Sì - Fornire il nome e codice prodotto della pompa (testo libero)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Clamp scorrevole blu scuro (slide clamp)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Clamp a scorrimento azzurro  (slide clamp)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Clamp incavata (notch clamp)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Clamp con ruota (roller clamp) ";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "Clamp a scorrimento bianco (slide clamp)";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "Sì - il morsetto, la clamp è rotta o con crepe";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "Aria nella Linea";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "Problemi con la clamp";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "Odore / puzza";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Rullo / pinza /morsetto ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Clamp con ruota (roller clamp)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Clamp che scorre (slide clamp)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "Con crepe / rotto ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "Difficile da aprire";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "Difficile da chiudere";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "Pezzi mancati ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "Impossibile aprire";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "Impossibile chiudere";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "Impossibile controllare il flusso";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "Camera di gocciolamento difficile da spremere";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "Le istruzioni per l'uso sono difficili da seguire/capire";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "Il prodotto era difficile da usare";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "Crepa/Rottura";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "Taglio";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "Disconnessione di collegamenti collegabili/prodotti collegati";
translations[DISCONNECTION_OF_CONNECTABLE] = "Disconnessione di collegamenti collegabili/prodotti collegati";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "Strappo/Buco ";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "Separazione di componenti incollati";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Acceesso aderente";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "Danni (fori, strappi) all'imballaggio secondario o al cartone intermedio ";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "Cartone di spedizione danneggiato durante la consegna";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "Esposizione a caldo/freddo estremo";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "Apertura del cartone di spedizione con un cutter o un oggetto tagliente";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "Nessuno dei precedenti";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "Usati dispositivi per misurare la pressione o per iniettare pressione";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "Animali domestici (segni di artigli o di masticamento)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "Prodotto";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "Scatola di spedizione";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "All'interno del prodotto";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "All'interno del cartone di spedizione";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "All'esterno del prodotto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "Difficoltà nel collegamento del prodotto a un altro prodotto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "Difficoltà di scollegamento del prodotto da un altro prodotto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "Connessione allentata";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "Separazione dei componenti in un singolo prodotto";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "Separazione/disconnessione del prodotto da un altro prodotto ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "Sull'esterno del cartone di spedizione";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "All'interno dell'imballaggio secondario/overbag";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "All'esterno dell'imballaggio secondario/overbag";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "Il flusso non scorre";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "Flusso limitato o parzialmente scorrevole";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "Problema al codice a barre -  Informazioni errate visualizzate quando viene scansionato codice a barre";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "Difficoltà nello scansionare il codice a barre o dice a barre non scansionabile";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "Etichetta illeggibile ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "Etichetta errata ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "Etichetta incompleta";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "Le etichette (prodotto, scatola/cartone, lista di spedizione) non hanno stesse informazioni sul prodotto";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "Etichetta troppo simile a un altro prodotto ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "Etichetta mancante ";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "Codice a barre mancante";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "Prodotto ricevuto congelato";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "Prodotto ricevuto scongelato";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "Sì, Allarme non noto";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "Sì, Specifica";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "Sì, il set di trasferimento non è in grado di essere completamente aperto";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "Sì, il set di trasferimento non è in grado di essere completamente chiuso";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "Sì -Il morsetto a torsione (twist clamp( era così stretto che il transfer set non si riusciva ad aprire ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "Sì -Il morsetto a torsione (twist clamp( era così stretto che il transfer set non si riusciva a chiudere ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "Scatola o confezione esterna ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Clamp blu sulla linea di ultimo riempimento";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassetta";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Connettori della linea di scarico e tappi a strappo (tappi a strappo)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Sito per il campionamento dell'effluente";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Linee";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Luer/Connettore perforatore";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizzatore";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Tappo a strappo/protezione punta sulla linea del paziente";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Tappo a strappo/protezioni per punta ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Clamp rossa sulla linea di riscaldamento";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Saldatura ";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "Clamp bianca sulla linea di provvigione";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Catetere beige adattatore connettore";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Inserto chip ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Connettore blu scuro ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Corpo principale azzurro ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Tappo a strappo azzurro ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Occlusore azzurro";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Tubo di silicone";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Perforatore titanio";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV Flash Spike (Perforatore) ";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "Twist clamp bianca/ manicotto";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "Sì: descrivere il danno (testo libero)";
translations[OPTION_MONTHOPTIONS_JAN] = "Gen";
translations[OPTION_MONTHOPTIONS_FEB] = "Feb";
translations[OPTION_MONTHOPTIONS_MAR] = "Mar";
translations[OPTION_MONTHOPTIONS_APR] = "Apr";
translations[OPTION_MONTHOPTIONS_MAY] = "Mag";
translations[OPTION_MONTHOPTIONS_JUN] = "Giu";
translations[OPTION_MONTHOPTIONS_JUL] = "Lug";
translations[OPTION_MONTHOPTIONS_AUG] = "Ago";
translations[OPTION_MONTHOPTIONS_SEP] = "Set";
translations[OPTION_MONTHOPTIONS_OCT] = "Ott";
translations[OPTION_MONTHOPTIONS_NOV] = "Nov";
translations[OPTION_MONTHOPTIONS_DEC] = "Dic";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "Altro";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "Altro";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "Altro (Testo Libero)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "Nessuno dei precedenti";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "No";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "Sì";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "No";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "Sì";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "No";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "Sì";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "No";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "Sì";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "Chiesto ma sconosciuto";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "Sconosciuto";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "Sì";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "Sì";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "Sì";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "No";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "Sì";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "No";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "Sì";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "Sì";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "No";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "Sì";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "No";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "Sì";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "No";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "Sì";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "No";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "Sì";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "Sì";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "No";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "Sì";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "No";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "Sì";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "Sì";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "No";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "Sì";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "No";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "Sì";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "Sì";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "No";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "Sì";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "No";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "Sì";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "No";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "Sì";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "No";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "Sì";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "No";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "Sì";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "No";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "Sì";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "No";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "Sì";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "No";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "No";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "Sì";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "Sì";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "No";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "Sì";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "No";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "Sì";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "No";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "Sì";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "No";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "Sì";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "No";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "Sì";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "No";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "Sì";
translations[OPTION_vaporizerSightGlassOptions_NO] = "No";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "Sconosciuto";
translations[OPTION_vaporizerSightGlassOptions_YES] = "Sì";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "No";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "Sì";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "No";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "Sì";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "Sì";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "Sì";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "Sì";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "No";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "Sì";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "No";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "Sì";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "No";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "Sì";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "No";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "Sì";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "No";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "Sconosciuto";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "Sì";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "No";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "Sì";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "Sì";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "No";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "Sì";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "No";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "Sì";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "No";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "Sì";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "No";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "Sì";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "Sì";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "Sì";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "No";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "Sì";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "Sì";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "Sì";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "No";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "Sì";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "No";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "Sì";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "No";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "Sì";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "No";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "Sì";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "No";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "Sì";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "No";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "Sì";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "No";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "Sì";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "No";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "Sì";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "No";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "Sì";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "No";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "No";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "Sì";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "No";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "No";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "Sì";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "No";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "Sì";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "No";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "Sì";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "No";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "Sì";
translations[OPTION_WITHPUMPOPTIONS_NO] = "No";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "No";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "Sì";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "No";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "No";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "Sì";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "No";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "Sì";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "No";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "Sì";
translations[OPTION_GELPACKSOPTIONS_NO] = "No";
translations[OPTION_GELPACKSOPTIONS_YES] = "Sì";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "No";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "Sì";
translations[OPTION_ALARMOPTIONS_NO] = "No";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "No";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "Sì";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "No";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "No";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "Sì";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "No";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "Sì";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "No";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "No";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "Sì";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "Altro (Testo Libero)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "No";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "Sì";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "No";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "Sì";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "No";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "Sì";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "Chiesto ma sconosciuto";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "Chiesto ma sconosciuto";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "Sconosciuto ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "No";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "Nessuno dei precedenti";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "No - descrivi il colore (testo libero)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "Sì - Specificare lo strumento utilizzato (testo libero)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "Separazione";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "Niente ";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "Sì - Altro (testo libero)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "No";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "Chilogrammo(i)";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "Libbra(e)";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "No";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "Sconosciuto";
translations[PLEASE_ENTER_THE_VALUE] = "Inserire il valore";
translations[PLEASE_SELECT_THE_VALUE] = "Seleziona il valore";
translations[PLEASE_SELECT_THE_DATE] = "Per favore, selezionare una data ";
translations[PLEASE_CHOOSE_THE_VALUE] = "Scegliere il valore";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "Sconosciuto";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GRAN BRETAGNA";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NORD IRLANDA";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ISOLE ÅLAND";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "SAMOA AMERICANE";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARTIDE";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA E BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BIELORUSSIA";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIO";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA E HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "ISOLA BOUVET ";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRASILE";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "TERRITOREIO BRITANNICO DELL'OCEANO INDIANO ";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBOGIA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMEROON";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CAPO VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "ISOLE CAYMAN ";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "REPUBBLICA CENTRALE AFRICANA";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "ISOLA DI NATALE";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "ISOLE COCOS (KEELING) ";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "REPUBBLICA DEMOCRATICA DEL CONGO";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "ISOLE COOK ";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "COSTA D'AVORIO";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROAZIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CIPRO";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "REPUBBLICA CECA";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DANIMARCA";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "REPUBBLICA DOMINICANA";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGITTO";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "GUINEA EQUATORIALE";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "ISOLE FALKLAND  (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "ISOLE FAROE ";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLANDIA";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "GUIANA FRANCESE";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "POLINESIA FRANCESE";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "TERRITORI AUSTRALI FRANCESI";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "GERMANIA";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBILTERRA";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GRECIA";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GROENLANDIA";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "ISOLE HEARD E ISOLE MCDONALD ";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "CITTA' DEL VATICANO ";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "UNGHERIA";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ISLANDA";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, REPUBBLICA ISLAMICA";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRLANDA";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISOLE DI MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAELE";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALIA";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "GIAPPONE ";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "GIORDANIA";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAKHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENYA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA DEL NORD Repubblica Popolare Democratica di Corea";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA DEL SUD, REPUBBLICA DI KOREA";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KYRGYZSTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAOS Repubblica Popolare ";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LETTONIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LIBANO";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBIA ARAB JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUSSEMBURGO";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALESIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVES";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "ISOLE MARSHALL ";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MESSICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "STATI FEDERALI DI MICRONESIA";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDAVIA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MAROCCO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "PAESI BASSI ";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NUOVA CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NUOVA ZELANDA";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "ISOLE NORFOLK ";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NORTHERN MARIANA ISLANDS";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORVEGIA";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINA ";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEW GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "FILIPPINE";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLONIA";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTOGALLO";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROMANIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSSIA";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SAINT HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS AND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOVAKIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SOLOMON ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SUD AFRICA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPAGNA";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD AND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SVEZIA";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SWITZERLAND";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "REPUBBLICA ARABA SIRIANA";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, UNITED REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD AND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNISIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURCHIA";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS AND CAICOS ISLANDS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UCRAINA ";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "EMIRATI ARABI UNITI";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "REGNO UNITO ";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "STATI UNITI D'AMERICA";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "UNITED STATES MINOR OUTLYING ISLANDS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIET NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "VIRGIN ISLANDS, BRITISH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "VIRGIN ISLANDS, U.S.";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTERN SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "No";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "Sconosciuto";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "Sì";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "Ho letto e compreso l'Informativa sulla privacy collegata per il portale di feedback sui prodotti Baxter. ";
translations[PRODUCT_LOT] = "Lotto prodotto ";
translations[SHIPPING_DISTRIBUTION_LABEL] = "Etichetta di spedizione/distribuzione";
translations[CARTON_LABEL] = "Etichetta in cartone";
translations[INTERNAL_PRODUCT_LABEL] = "Etichetta interna del prodotto";
translations[TITLE_PD_RENAL] = "PD renale";
translations[TITLE_SOLUTIONS] = "Soluzioni";
translations[TITLE_ACCESS] = "Accesso";
translations[TITLE_ALL_OTHER_PRODUCT] = "Tutti gli altri prodotti";
translations[REPORTED_PROBLEM] = "Problema segnalato";
translations[LOGIN] = "Login";
translations[SYSTEM_MENU] = "Menù di sistema";
translations[INITIATE_PRODUCT_FEEDBACK] = "Iniziare una segnalazione su un prodotto ";
translations[FEEDBACK_STATUS] = "Stato di feedback";
translations[OKTACALLBACK] = "OktaRichiamata";
translations[VALID_EMAIL] = "Inserire un indirizzo email valido";
translations[VALID_NUMERIC] = "Inserire il numero completo.";
translations[PLEASE_UPLOAD_IMAGE] = "Caricare immagine/i";
translations[VALID_DATE] = "Seleziona una data valida";
translations[QUANTITY] = "Quantità";
translations[EDIT] = "Modificare";
translations[DELETE] = "Elimina";
translations[LOT_SERIAL_NO] = "Lotto/numero di serie";
translations[LOT_NUMBER_NOT_FOUND] = "Numero di lotto non trovato";
translations[SEARCHING_LOT_NUMBER] = "Ricerca del numero di lotto";
translations[PRODUCT_CODE_NOT_FOUND] = "Codice del prodotto non trovato";
translations[SEARCHING_PRODUCT_CODE] = "Ricerca del codice del prodotto ";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "Formati di file non ammessi (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps)";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = " Il file che stai tentando di allegare supera il limite di archiviazione. Per favore, comprimere il file o allegare un file differente";
translations[IMAGE_ICON] = "Cliccare sull'immagine icona per selezionare l'opzione";
translations[LOGIN_TO_ACCOUNT] = "Accedi all'account";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "Accedi al tuo account";
translations[BAXTER_EMAIL_ADDRESS] = "Indirizzo e-mail Baxter";
translations[PASSWORD] = "Parola d'ordine";
translations[SIGN_IN] = "Registrazione";
translations[UNKNOWN] = "Sconosciuto";
translations[ASKED_UNKNOWN] = "Chiesto ma sconosciuto";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "Seleziona paese";
translations[CHINESE_SIMPLIFIED_CHINESE] = "Cinese (Cinese semplificato)";
translations[DUTCH] = "Olandese";
translations[ENGLISH] = "Inglese";
translations[FRENCH] = "Francese";
translations[GERMAN] = "Tedesco";
translations[ITALIAN] = "Italiano";
translations[JAPANESE] = "Giapponese";
translations[KOREAN] = "Coreano";
translations[MANDARIN_TRADITIONAL_CHINESE] = "Mandarino (Cinese tradizionale)";
translations[POLISH] = "Polacco";
translations[PORTUGUESE] = "Portoghese";
translations[SPANISH] = "Spagnolo";
translations[THAI] = "Thai";
translations[TURKISH] = "Turco";
translations[VIETNAMESE] = "Vietnamita";
translations[BROWSE] = "Navigare";
translations[FEEDBACK_SUBMITTED] = "Feedback inviato";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "Il vostro riscontro sull'esperienza del prodotto è stato inviato con successo. Grazie per la vostra segnalazione. Riceverete un'e-mail contenente un numero di riferimento. In qualità di fornitore di prodotti medicali, la soddisfazione dei clienti e il riscontro riguardo ai nostri prodotti sono essenziali per il nostro obiettivo di fornire prodotti di altissima qualità. Si prega di contattare";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "se hai domande o ulteriori informazioni.";
translations[CLOSE] = "Chiudere";
translations[PATIENT_AGE] = "Età del paziente";
translations[ENTER_AGE] = "Inserisci Età";
translations[PATIENT_DOB] = "Data di nascita del paziente";
translations[RELEVANT_ATTACHMENTS] = "Fornire tutti gli allegati che si ritengono pertinenti per descrivere l'evento ";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "Inserire le credenziali dell'account Baxter";
translations[GET_PRODUCT_DETAILS] = "Ottieni i dettagli del prodotto";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "Utilizzare il diagramma sopra (figura 2) per determinare la posizione del problema segnalato";
translations[FACILITY_ADDRESS] = "Indirizzo della struttura ospedaliera";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "Altro indirizzo della struttura ospedaliera";
translations[CHOOSE_PRODUCT_CODE] = "Selezionare il Codice Prodotto per il Numero di Lotto o Numero di Serie inserito ";
translations[DECLINE] = "Declino";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS E SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURACAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SUDAN DEL SUD";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "indica che il testo guida è disponibile per questo campo";
translations[YOUR_FIRST_NAME] = "Il tuo nome";
translations[YOUR_LAST_NAME] = "Il tuo cognome";
translations[MY_FIRST_NAME] = "Il mio nome";
translations[MY_LAST_NAME] = "Il mio cognome";
translations[PATIENT_FIRST_NAME] = "Nome del paziente";
translations[PATIENT_LAST_NAME] = "Cognome del paziente";
translations[REPORTER_FIRST_NAME] = "Nome del reporter";
translations[REPORTER_LAST_NAME] = "Cognome del reporter";
translations[EMPLOYEE_FIRST_NAME] = "Nome del dipendente";
translations[EMPLOYEE_LAST_NAME] = "Cognome del dipendente";
translations[END_USER_CUSTOMER_FIRST_NAME] = "Nome del cliente ";
translations[END_USER_CUSTOMER_LAST_NAME] = "Cognome del cliente ";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "Nome del contatto aggiuntivo";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "Cognome del contatto aggiuntivo";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "Tutti i diritti riservati | Versione";
translations[ADD_ADDITIONAL_CONTACT] = "Aggiungi un altro contatto ";
translations[CONTACT_ME] = "Il cliente non desidera essere contattato. Contattami per ulteriori domande.";
translations[DO_NOT_CONTACT] = "Non contattare";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "Nome della struttura ";
translations[END_USER_CUSTOMER_PHONE] = "Numero di telefono della struttura ";
translations[END_USER_CUSTOMER_EMAIL] = "Indirizzo e-mail del cliente ";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "Indirizzo della struttura ";
translations[SAME_AS_PATIENT_ADDRESS] = "Stesso indirizzo paziente";
translations[SAME_AS_REPORTER_ADDRESS] = "Stesso indirizzo della persona che ha effettuato la segnalazione";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "Stesso indirizzo della struttura ";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "Utilizzare il diagramma sovrastante (Figura 3) per determinare la posizione del problema segnalato";
translations[CONTACT_US] = "Contattaci";
translations[LANDING_BRIEF_FOR_DEVICE] = "Per riparazioni, componenti, servizi o supporto tecnico del dispositivo, contattare il team di servizio assistenza tecnica locale.";
translations[PATIENT_SEX] = "Sesso del paziente";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "Uomo/ragazzo cisgender";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "Donna/ragazza cisgender";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "Uomo transgender/uomo trans/da donna a uomo";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "Donna transgender/donna trans/maschio-femmina";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "Altra categoria di genere; per favore specificare";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "Rifiuta di rispondere";
translations[ATTENTION_NEEDED] = "!!! ATTENZIONE URGENTE NECESSARIA: L'invio del Product Feedback Portal non è riuscito!";
translations[SUBMIT_ERR_MSG] = "Per inviare nuovamente, fai clic su OK e quindi su Invia oppure invia il reclamo via email a (@@@).";
translations[SUBMIT_RETRY_MSG] = "Se l'hai inviato nuovamente, verifica di aver ricevuto un'e-mail di conferma nella tua casella di posta elettronica dal Product Feedback Portal. Se non è stata ricevuta alcuna e-mail di conferma, l'invio non è andato a buon fine e DEVI inviare il reclamo via e-mail a (@@@).";
translations[OK] = "OK";

export default lang;